module.exports = __webpack_public_path__ + "media/images/creator/monitor/kv@3x-01b4fe95c7562499b2548bc41ad80a8e.png";